import React from 'react';
import {View} from 'react-native';
import {makeStyles} from '@rn-vui/themed';

import Text from '../../themed/Text';

const useStyles = makeStyles((_theme, _props: InStoreCodeProps) => ({
  codeText: {
    // lineHeight: '125%',
    fontSize: 28,
  },
}));

type InStoreCodeProps = {
  color?: string;
  inStoreCode: string;
};

export default function InStoreCode({inStoreCode, color}: InStoreCodeProps) {
  const _styles = useStyles();
  return (
    <View style={{marginTop: 20, alignSelf: 'stretch'}} testID="code-container">
      <Text color={color} variant="body2" style={{marginBottom: 8}} testID="code-label">
        Rewards in-store code
      </Text>
      {/* <Text style={[styles.codeText]}>{inStoreCode}</Text> */}
      <DisplayCode value={inStoreCode} />
    </View>
  );
}

/**
 * Show code as individual chars
 * @param param0
 * @returns
 */
function DisplayCode({value}: {value: string}) {
  return (
    <View style={{flexDirection: 'row', gap: 8}} testID="display-code-container">
      {value.split('').map((char, i) => {
        return (
          <View
            key={i}
            testID="code-char-container"
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              backgroundColor: '#EFEFEF',
              borderColor: '#D1D5DB',
              borderWidth: 1,
              flexGrow: 1,
              height: 44,
            }}>
            <Text
              testID="code-char-text"
              style={{
                textSize: 22,
                marginTop: 3,
              }}>
              {char}
            </Text>
          </View>
        );
      })}
    </View>
  );
}
